import Data from 'data';
import { skillFormula } from '../calc';

import { missileDamage } from "../damage";
import { missileDPS } from '../dps';

const functions = {};

// Wake of Inferno (Sentry Skill)

functions[95] = {
  damage(skill, stats, weapon, level, target) {
    const frames = skillFormula(skill, 'clc2', stats, level);
    const density = skillFormula(skill, 'clc3', stats, level);
    return missileDamage(Data.missileByName[skill.srvmissilea], stats, weapon, level, target, {ticks: Math.ceil(frames / density)});
  },
  dps(id, stats, level, target, info) {
    const skill = Data.skills[id];
    const missile = Data.missileByName[skill.srvmissilea];
    if (!missile) return;
    return missileDPS(skill, missile, stats, level, target, info, info.damage.damage.ticks);
  },
};

export default functions;
